import { getBrand } from '@eforms/forms-common-ui';

export const DEFINITION_ROOT = '/api/definition';

export const FORM_ROOT = '/forms';

export const TEAMS_API_PATH = '/api/definition/teams';

export const LWB_REDIRECT_API_PATH = `/api/authentication/${getBrand()}/lwb/redirect`;

export const LWB_ASSERTION_API_PATH = `/api/authentication/${getBrand()}/lwb/assertion`;

export const FORM_FEEDBACK_SAVE = '/forms';
